import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=c38b953a&"
import script from "./section2.vue?vue&type=script&lang=js&"
export * from "./section2.vue?vue&type=script&lang=js&"
import style0 from "./section2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports